import { Routes } from '@angular/router';

export const AUTH_ROUTES: Routes = [
	{
		path: 'account-request',
		loadComponent: () =>
			import('../account/apple-request-account/apple-request-account.component').then(
				(m) => m.AppleRequestAccountComponent,
			),
	},
	{
		path: 'callback',
		loadComponent: () =>
			import('../account/apple-auth-callback/apple-auth-callback.component').then((m) => m.AppleAuthCallbackComponent),
	},
	{
		path: 'account-request/confirmation',
		loadComponent: () =>
			import('../account/apple-request-account-confirmation/apple-request-account-confirmation.component').then(
				(m) => m.AppleRequestAccountConfirmationComponent,
			),
	},
	{
		path: 'login',
		loadComponent: () => import('../account/apple-login/apple-login.component').then((m) => m.AppleLoginComponent),
	},
	{
		path: 'forgot-password',
		loadComponent: () =>
			import('../account/apple-forgot-password/apple-forgot-password.component').then(
				(m) => m.AppleForgotPasswordComponent,
			),
	},
	{
		path: 'forgot-password/confirmation',
		loadComponent: () =>
			import('../account/apple-forgot-password-confirmation/apple-forgot-password-confirmation.component').then(
				(m) => m.AppleForgotPasswordConfirmationComponent,
			),
	},
	{
		path: 'forgot-password/:reset_token',
		loadComponent: () =>
			import('../account/apple-password-reset/apple-password-reset.component').then(
				(m) => m.ApplePasswordResetComponent,
			),
	},
	{
		path: 'registration/:login_method/:uuid_token',
		loadComponent: () =>
			import('../account/apple-registration/apple-registration.component').then((m) => m.AppleRegistrationComponent),
	},
];
